export default "__VITE_ASSET__hjTop1Fn__"